import { render, staticRenderFns } from "./WalletAutocomplete.vue?vue&type=template&id=b7c5f5d2&scoped=true&"
import script from "./WalletAutocomplete.vue?vue&type=script&lang=ts&"
export * from "./WalletAutocomplete.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7c5f5d2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
installComponents(component, {VAutocomplete})
